<div class="wrapper msm-theme">
  <div class="inner-wrapper">
    <a href="https://n2b.somosnexho.com/app"
      ><img
        src="assets/img/logos/mahou-logo-white.svg"
        alt="mahou logo white"
        class="logo"
    /></a>
    <div class="right">
      <a
        href="https://www.somosnexho.com/ayuda/contacta-con-nosotros?faqCategory=servicio-de-incidencias-de-barril"
        ><img src="assets/img/triangulo-naranja.png" alt="" class="triangle"
      /></a>
      <a href=""></a
      ><img src="assets/img/nexho_user.svg" alt="user icon" class="person" />

      <ul class="list">
        <li class="list-element">
          <a href="https://n2b.somosnexho.com/app"
            >Usuario de <strong>{{ user().partner_username }}</strong></a
          >
        </li>
        <li class="list-element">
          <a href="https://n2b.somosnexho.com/app">... pts</a>
        </li>
        <li class="list-element">
          <a href="https://n2b.somosnexho.com/app"
            >acceder <span class="red">(0)</span></a
          >
        </li>
        <li class="list-element">
          <a href="https://n2b.somosnexho.com/app">desconectar</a>
        </li>
      </ul>

      <div class="search">
        <a href="https://n2b.somosnexho.com/app"
          ><img
            class="search"
            src="assets/img/nexho_search.svg"
            alt="search field"
            class="search"
        /></a>
      </div>
    </div>
  </div>
</div>
